<template>
  <no-ssr>
    <div class="booking-popup-mobile" >
      <transition name="fade" mode="out-in">
        <form
          v-if="offers.length && offer.id"
          class="booking-popup-mobile__form"
          @submit.prevent="onSubmit('Tour detail')"
        >
          <div class="booking-popup-mobile__wrapper">
            <div

              class="booking-popup-mobile__wrapper-container"
            >

              <template v-if="!outOfPlaces">

                <div v-if="isShowMinPrice" class="booking-popup-mobile__prices" @click="scrollToImportant">

                  <div class="booking-popup-mobile__prices-result font-h0">
                    <template v-if="customOfferSelected || (isShowMinPrice && !offerSelected)"
                    > {{ $t("bookingPopup.from") }} </template
                    >{{ symbol }} {{ priceResultFormatted }}
                  </div>

                  <div
                    v-if="hasDiscount"
                    class="
                      booking-popup-mobile__prices-original
                      font-h0
                      u-text-secondary
                    "
                  >
                    {{ priceOriginalFormatted }}
                  </div>

                  <div
                    v-if="hasDiscount"
                    class="booking-popup-mobile__prices-discount"
                  >
                    {{ offer.discountValue }}
                  </div>
                </div>



                <div v-else class="booking-popup-mobile__prices" @click="scrollToImportant">
                  <div
                    v-if="hasDiscount"
                    class="
                      booking-popup-mobile__prices-original
                      font-h0
                      u-text-secondary
                    "
                  >
                    {{ priceOriginalFormatted }}
                  </div>
                  <div class="booking-popup-mobile__prices-result font-h0">
                    <template v-if="customOfferSelected"
                    >{{ $t("bookingPopup.from") }} </template
                    >{{ symbol }} {{ priceResultFormatted }}
                  </div>
                  <div
                    v-if="hasDiscount"
                    class="booking-popup-mobile__prices-discount"
                  >
                    {{ offer.discountValue }}
                  </div>
                </div>
                <div
                  v-if="installmentAvailable"
                  class="booking-popup-mobile__installment font-text"
                  @click="triggerInstallmentPopup()"
                >
                  <span>
                    {{
                      $t("bookingPopup.installment.tooltip", {
                        symbol,
                        from: installmentPriceFormatted,
                      })
                    }}
                  </span>
                  <tooltip wrap-after-text></tooltip>
                  <popup-installment v-model="popups.installment" />
                </div>
                <div class="booking-popup-mobile__days font-semibold u-text-secondary">
                  <template v-if="!installmentAvailable">
                    <div>
                      <span class="u-text-black"
                      >{{ symbol }} {{ priceDayFormatted }}</span
                      >
                      /
                      {{ $t("bookingPopup.day") }}
                    </div>
                    <divider-dot class="u-text-secondary" />
                  </template>
                  <div>
                    {{
                      (installmentAvailable
                        ? $t("bookingPopup.duration")
                        : "") + $tc("common.days", days)
                    }}
                  </div>
                  <template v-if="offer.s7Miles">
                    <div class="booking-popup-mobile__s7">
                      <icon icon="s7" />
                      <span>+{{ offer.s7Miles }}</span>
                    </div>
                  </template>
                  <template v-if="offer.utairMiles">
                    <div class="booking-popup-mobile__utair">
                      <icon icon="utair" />
                      <span>+{{ offer.utairMiles }}</span>
                    </div>
                  </template>
                </div>
              </template>
              <div
                v-if="outOfPlaces"
                class="booking-popup-mobile__out-of-places u-text-center"
              >
                <div class="booking-popup-mobile__out-of-places-smile">😔</div>
                <div class="booking-popup-mobile__out-of-places-text font-semibold">
                  <div v-html="$t('bookingPopup.outOfPlaces.text.over')"></div>
                  <div class="u-text-secondary">
                    <span
                      v-html="$t('bookingPopup.outOfPlaces.text.leave')"
                    ></span>
                    <span
                      v-html="$t('bookingPopup.outOfPlaces.text.pick')"
                    ></span>
                  </div>
                </div>
                <yt-button
                  type="submit"
                  color="gray"
                  class="booking-popup-mobile__submit-button u-w-full"
                  :disabled="pending"
                  :squared = "true"
                >
                  {{ $t("bookingPopup.outOfPlaces.submit") }}
                </yt-button>
              </div>
              <template v-else>
                <booking-popup-fieldset
                  ref="bookingPopupFieldset"
                  :selected-offer.sync="$v.formData.offer.$model"
                  :offers="offers"
                  :is-custom-offer="customOfferSelected"
                  :participants.sync="$v.formData.participants.$model"
                  :offer="offer"
                  :pending="pending"
                  :is-offer-selected="offerSelected"
                  :is-show-min-price="isShowMinPrice"
                  :is-all-offers-loaded="isAllOffersLoaded"
                  :await-next-page="awaitNextPage"
                  class="booking-popup-mobile__fieldset"
                  @update:selectedOffer="$emit('update:selectedOffer', {'isOfferSelected': true, 'formData': formData})"
                  @scroll-end="$emit('scroll-end')"
                />
                <div
                  class="booking-popup-mobile__left u-text-center"
                  :class="leftColorClasses"
                  v-if="!isShowMinPrice || (isShowMinPrice && offerSelected)"
                >
                  <button-icon tag="span">
                    <template v-if="leftLessThanHalf" #icon>
                      <icon icon="lightning" :class="leftColorClasses" />
                    </template>
                    <span class="font-semibold" v-html="leftText"></span>
                  </button-icon>
                </div>
                <div
                  v-if="offer.guarantee || tour.momental_book"
                  class="booking-popup-mobile__badges"
                >
                  <badge v-if="offer.guarantee" class="booking-popup-mobile__badge"
                         @tooltipShow="onTooltipShow($t('bookingPopup.badges.guarantee.title'));"
                         @tooltipHide="onTooltipHide($t('bookingPopup.badges.guarantee.title'));"
                  >
                    <span
                      v-html="$t('bookingPopup.badges.guarantee.title')"
                    ></span>
                    <template #tooltip>
                      <div class="u-text-center"
                           v-html="$t('bookingPopup.badges.guarantee.tooltip')"
                      ></div>
                    </template>
                  </badge>
                  <badge v-if="tour.momental_book" class="booking-popup-mobile__badge"
                         @tooltipShow="onTooltipShow($t('bookingPopup.badges.instant.title'));"
                         @tooltipHide="onTooltipHide($t('bookingPopup.badges.instant.title'));"
                  >
                    <span
                      v-html="$t('bookingPopup.badges.instant.title')"
                    ></span>
                    <template #tooltip>
                      <div class="u-text-center"
                           v-html="$t('bookingPopup.badges.instant.tooltip')"
                      ></div>
                    </template>
                  </badge>
                </div>


                <div class="booking-popup-mobile__submit">
                  <yt-button
                    v-if="!offerSelected && isShowMinPrice"
                    class="booking-popup-mobile__submit-button u-flex-shrink-0"
                    :disabled="bookingDisabled "
                    @click="openMultiSelect"
                    :squared = "true"
                  >
                    {{ $t('bookingPopup.chooseDates') }}
                  </yt-button>
                  <yt-button
                    v-else
                    type="submit"
                    class="booking-popup-mobile__submit-button u-flex-shrink-0"
                    :disabled="bookingDisabled"
                    @click="trackClickActionButton"
                    :squared = "true"
                  >
                    {{ bookingButtonTitle }}
                  </yt-button>
                </div>

                <div class="booking-popup-mobile__note u-text-center u-text-secondary">
                  <div
                    v-if="prepayPriceResult"
                    class="font-text-small"
                  >
                    {{ $t('bookingPopup.note.prepayment') }} - {{ prepayment }} {{ symbol }}
                  </div>
                  <div
                    v-else
                    class="font-text-small"
                    v-html="$t('bookingPopup.note.prepay')"
                  ></div>
                  <div v-if="offer.flexibleCancellation">
                    <span
                      class="font-text-small u-text-underline u-clickable"
                      v-html="$t('bookingPopup.note.flexible')"
                      @click="popups.flexible = true"
                    ></span>
                    <popup-flexible-cancellation v-model="popups.flexible" />
                  </div>
                  <div
                    v-else
                    class="font-text-small"
                    v-html="$t('bookingPopup.note.cancel')"
                  ></div>
                </div>
                <div
                  v-if="!!+tour.is_private"
                  class="booking-popup-mobile__individual"
                >
                  <span
                    class="
                      booking-popup-mobile__individual-trigger
                      font-semibold
                      u-text-green-dark u-clickable
                    "
                    v-html="$t('bookingPopup.individual.trigger')"
                    @click="triggerIndividualPopup()"
                  ></span>
                  <tooltip class="u-text-secondary"
                           wrap-after-text
                           @show="onTooltipShow($t('bookingPopup.individual.tooltipName'))"
                           @apply-hide="onTooltipHide($t('bookingPopup.individual.tooltipName'))"
                  >
                    <template #content>
                      <div class="u-text-center" v-html="$t(`bookingPopup.individual.tooltip`)"></div>
                    </template>
                  </tooltip>
                  <popup-individual v-model="popups.individual" :tour="tour" />
                </div>
              </template>
            </div>
          </div>

        </form>
        <div v-else :key="'preloader'" class="booking-popup-mobile__preloader">
          <div class="booking-popup-mobile__preloader-container">
            <preloader visible />
          </div>
        </div>
      </transition>
      <popup
        v-model="bookingPopupOpen"
        size="sm"
        @close="closeBookingPopupHandler"
      >
        <template v-if="!showRedirectPopupLoaded">
          <component
            class="booking-popup-mobile__add-order"
            :is="getComponentName"
            :userData="userData"
            @send-contact-submit = "sendContactBookingHandler"
            @loaded="loadedHandler"
          >
          </component>
          <preloader position="absolute" :visible="!popupLoaded" />
          <div v-show="showPopupLoaderBg"  class="popup-preloader-background"></div>
        </template>
        <component
          v-if="showRedirectPopup"
          :is="getRedirectPopup"
          :userData="userData"
          @redirect-submit="redirectHandler"
          @loaded="loadedHandler"
        />
        <div v-if="errorMessage" class="booking-popup-mobile__error">
          <div class="booking-popup-mobile__error-title">{{ $t("bookingPopup.error")}}</div>
          <div v-html="errorMessage" class="booking-popup-mobile__error-msg"></div>
          <yt-button
            class="popup-redirect__submit"
            color="green"
            :squared="false"
            @click="closeBookingPopupHandler"
          >
            OK
          </yt-button>
        </div>
      </popup>
    </div>
  </no-ssr>
</template>

<script>
import Cookies from "js-cookie";
import { i18n } from "@/plugins/i18n";
import { mapState, mapGetters } from "vuex";
import { sizeMdMax } from "@/assets/js/utils/mq";
import { required, maxValue, minValue } from "vuelidate/lib/validators";
//import { axiosOffers } from "@/services/scopes/axios-offers";
import { axiosOrders } from "@/services/scopes/axios-orders";
import { axiosUser } from "@/services/scopes/axios-user";
import { parse, intervalToDuration } from "date-fns";

import getFormattedDateRange from "@/assets/js/utils/get-formatted-date-range";
import thousandsSeparator from "@/assets/js/utils/thousandsSeparator";
import BookingPopupFieldset from "@/components/organisms/booking-popup-mobile/fieldset.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import ButtonIcon from "@/components/ui-kit/button-icon/index.vue";
import Icon from "@/components/icons/index.vue";
import Badge from "@/components/ui-kit/badge/index.vue";
import YtButton from "@/components/ui-kit/yt-button/index.vue";
import DividerDot from "@/components/ui-kit/divider-dot/index.vue";
import DropdownTrigger from "@/components/ui-kit/dropdown-trigger/index.vue";
import PopupFlexibleCancellation from "@/components/organisms/popup-flexible-cancellation/index.vue";
import Preloader from "@/components/ui-kit/preloader/index.vue";
import Tooltip from "@/components/ui-kit/tooltip/index.vue";
import PopupIndividual from "@/components/organisms/popup-individual/index.vue";
import PopupInstallment from "@/components/organisms/popup-installment/index.vue";
import noSSR from "vue-no-ssr";
import { ytEvents } from "@/plugins/analytics";
import Popup from "@/components/ui-kit/yt-popup";
import { abTestController } from "@/plugins/abtest";

export default {
  components: {
    Popup,
    BookingPopupFieldset,
    SvgInline,
    ButtonIcon,
    Icon,
    Badge,
    YtButton,
    DividerDot,
    DropdownTrigger,
    PopupFlexibleCancellation,
    Preloader,
    Tooltip,
    PopupIndividual,
    PopupInstallment,
    "no-ssr": noSSR,
  },
  props: {
    tour: {
      type: Object,
      required: true,
    },
    offerSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    formData: {
      type: Object,
      required: true,
    },
    offers: {
      type: Object,
      required: true,
    },
    offer: {
      type: Object,
      required: true,
    },
    isShowMinPrice: {
      type: Boolean,
      default: false,
    },
    isAllOffersLoaded: {
      type: Boolean,
      default: false,
    },
    awaitNextPage: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      pending: false,
      popupOpen: false,
      bookingPopupOpen: false,
      popups: {
        flexible: false,
        individual: false,
        installment: false,
      },
      popupLoaded: false,
      popupComponentName: '',
      showRedirectPopup: false,
      showRedirectPopupLoaded: false,
      paymentUrl: "",
      userData: {
        name: "",
        lastName: "",
        phone: "",
        email: ""
      },
      errorMessage: "",
      tooltipStartShowTime: [],
      trackingLabel: ""
    };
  },
  validations() {
    return {
      formData: {
        offer: {
          required,
        },
        participants: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(this.offer.freeSpaces),
        },
      },
    };
  },
  computed: {
    ...mapState("language", ["language"]),
    ...mapGetters("currency", ["symbol", "currencyId"]),
    ...mapGetters("user", ["getUserLoginStatus", "getUserContact"]),
    showPopupLoaderBg() {
      return (!this.showRedirectPopup && !this.popupLoaded) ||
        (
          this.showRedirectPopup &&
          !this.showRedirectPopupLoaded &&
          this.popupComponentName.length === 0
        );
    },
    datepickerLang() {
      return this.$t("dateSelector.datepickerLang");
    },
    minDays() {
      return this.days || 1;
    },
    minParticipants() {
      return this.formData.participants || 1;
    },
    priceOriginal() {
      return +this.offer.original_price * this.minParticipants;
    },
    priceOriginalFormatted() {
      return thousandsSeparator(this.priceOriginal);
    },
    priceResult() {
      if (this.customOfferSelected) {
        return +this.offer.price * this.minDays * this.minParticipants;
      }

      return +this.offer.price * this.minParticipants;
    },
    prepayPriceResult() {
      const prepayPrice = this.offer.prepay_price;

      if (!prepayPrice) {
        return null;
      }

      return +prepayPrice * this.minParticipants;
    },

    priceResultFormatted() {
      return thousandsSeparator(this.priceResult);
    },
    priceDay() {
      return (
        +(this.offer.price_day || this.tour.min_price) * this.minParticipants
      );
    },
    priceDayFormatted() {
      return thousandsSeparator(this.priceDay);
    },
    bonuses() {
      return parseInt(this.priceResult / 100 * this.userBonusLevel) ?? 0;
    },
    bonusesFormatted() {
      return thousandsSeparator(this.bonuses);
    },
    isShowBonuses() {
      return i18n.locale === "ru" && abTestController.getSegment(16449) === 'B';
    },

    isShowNewBookingPopups() {
      return abTestController.getSegment(15377) === 'B';
    },
    installmentAvailable() {
      return (
        this.currencyId === "rub" &&
        i18n.locale === "ru" &&
        !!this.tour.installment.available
      );
    },
    installmentPrice() {
      return +this.tour.installment.from;
    },
    installmentPriceFormatted() {
      return thousandsSeparator(this.installmentPrice);
    },
    hasDiscount() {
      return this.offer.discountValue && !this.customOfferSelected;
    },

    leftLessThanHalf() {
      return (
        this.offer.freeSpaces <=
        this.offer.totalSpaces / 2
      );
    },
    leftColorClasses() {
      return this.leftLessThanHalf ? "u-text-violet-3" : "u-text-green-dark";
    },
    leftText() {
      const free = this.offer.freeSpaces;

      return this.$t("bookingPopup.left", {
        free: free > 0 ? free : 0,
        total: this.offer.totalSpaces,
      });
    },
    customOfferSelected() {
      return !!this.offer.custom;
    },
    days() {
      if (this.customOfferSelected) {
        const {
          offer: { range },
        } = this;

        if (range.length) {
          return (
            intervalToDuration({
              start: parse(range[0], "dd.MM.yyyy", new Date()),
              end: parse(range[1], "dd.MM.yyyy", new Date()),
            }).days + 1
          );
        }

        return 0;
      }
      return this.offer.period_date_days;
    },
    outOfPlaces() {
      return this.offers.length === 1 && this.offer.custom;
    },
    bookingAvailable() {
      return this.offer.freeSpaces > 0;
    },
    bookingDisabled() {
      return (
        this.pending || !this.bookingAvailable || this.$v.formData.$invalid || this.bookingPopupOpen
      );
    },
    easyBooking() {
      return (
        !this.getUserLoginStatus &&
        (this.language.id === "ru" ||
          (this.language.id === "en" &&
            Cookies.get("BITRIX_SM_YT12059AB") === "y"))
      );
    },
    bookingButtonTitle() {
      /**
       * book: "Забронировать",
       fullyPaid: "Тур оплачен",
       payTour: "Оплатить тур",
       postPayTour: "Оплатить остаток",
       bookAgain: "Забронировать снова",
       awaitConfirm: "Ожидает подтверждения",
       */

      const buttonAction = this.bookingData;
      return buttonAction.title;
    },
    prepayment() {
      return thousandsSeparator(this.prepayPriceResult);
    },
    bookingData() {
      /**
       * book: "Забронировать",
       fullyPaid: "Тур оплачен",
       payTour: "Оплатить тур",
       postPayTour: "Оплатить остаток",
       bookAgain: "Забронировать снова",
       awaitConfirm: "Ожидает подтверждения",
       */
      const orderActions = this.offer.orderActions;
      let data = {
        sessid: fakeWindow.BX?.bitrix_sessid(),
        title: this.$t(`bookingPopup.book`),
        operation_id: 'book',
        action: !this.getUserLoginStatus ? 'ContactSandBook' : 'BookTour',
        init_action: 'BookTour',
        trigger: 'action',
        data: {
          date: this.formData.offer.id,
          template: "easybooktour",
          trip_id: this.tour.id,
          "people-counter": this.formData.participants,
        },
        backurl: fakeWindow.location?.pathname,
      };

      if(orderActions.haveOrder
        && !orderActions.isPrepaid
        && !orderActions.isPostpaid
      ){
        data = {
          ...data,
          ...{
            title: this.$t(`bookingPopup.payTour`),
            action:'link',
            url: orderActions.prePayUrl,
            operation_id: 'payTour',
          }
        };
      }

      if(orderActions.isPrepaid
        && !orderActions.isPostpaid
        && this.offer.collectPostPay
      ){
        data = {
          ...data,
          ...{
            title: this.$t(`bookingPopup.postPayTour`),
            action:'link',
            url: orderActions.postPayUrl,
            operation_id: 'postPayTour',
          }
        };
      }

      if(orderActions.haveOrder
        && orderActions.awaitForConfirmation
        && orderActions.isPrepaid
      ) {
        data = {
          ...data,
          ...{
            title: this.$t(`bookingPopup.awaitConfirm`),
            operation_id: 'awaitConfirm',
            init_action: 'WaitConfirm',
            action: 'ShowScreen',
            data: {'template': 'waitconfirm'},
          }
        };
      }
      return data;
    },
    getRedirectPopup(){
      if(this.bookingPopupOpen) {
        return () => import(`@/components/organisms/booking_popups/popup-redirect/index.vue`);
      }
      return "";
    },
    getComponentName() {

      if(this.bookingPopupOpen) {
        if(this.popupComponentName.length){
          return () => import(`@/components/organisms/booking_popups/popup-${this.popupComponentName}/index.vue`);
        }
      }
      return "";
    },
    sizeMdMax,
  },
  mounted() {


    fakeWindow.addEventListener("yt.putModalContent", this.onPutModalContent);
  },
  beforeDestroy() {
    fakeWindow.removeEventListener("yt.putModalContent", this.onPutModalContent);
  },
  watch: {
    "formData": {
      deep: true,
      handler(value) {
        this.$emit("changeFormData", value);
      },
    },

    offer: {
      deep: true,
      handler(offer) {
        this.$emit("change", { ...offer });
      },
    },
  },
  methods: {
    async pick() {
      if (this.pending) {
        return;
      }

      this.popupComponentName = 'help-me';
      this.pending = true;
      this.bookingPopupOpen = true;
    },
    async book() {
      this.$v.formData.$touch();

      if (this.bookingDisabled) {
        return;
      }

      if(this.bookingData.action === 'link') {
        fakeWindow.location.href = this.bookingData.url;
        return;
      }

      this.pending = true;

      if(!this.isShowNewBookingPopups && this.bookingData.action == 'BookTour') {
        let ytObj = youtravel || {};
        if (typeof ytObj.ModalController !== "undefined") {
          this.bookingData.tracking_label = this.trackingLabel;
          ytObj.ModalController.openModal({
            ajax_mode: true,
            ajax_type: "POST",
            ajax_url: "/local/ajax/booking/ajax.booking.php",
            bodyRequest: this.bookingData,
          });
        }
      }
      else {
        // Авторизованному телефон не обязателен (в т.ч. после identify) — не открываем send-phone.

        this.bookingPopupOpen = true;

        if(!this.getUserLoginStatus) {

          const userInfo = await axiosOrders.getUserData()
            .then(({data}) => {
              if(data.success) {
                return data.data
              }
            })

          this.userData.name = userInfo.name || "";
          this.userData.lastName = userInfo.last_name || "";
          this.userData.email = userInfo.email || "";
          this.userData.phone = userInfo.personal_phone || "";

          if(this.userData.email
            && this.userData.phone.length == 0
            && this.userData.name
            && this.userData.lastName
          ){
            this.popupComponentName = 'send-phone';
          }
          else {
            this.popupComponentName = 'send-contact';
          }
        }

        if (this.popupComponentName.length == 0) {
          const phoneFormated = this.getUserContact.personalPhone || this.userData.phone || ""
          const orderData = {
            "tourId": this.tour.id,
            "peopleCounter": this.getParticipantsCount(),
            "date": this.formData.offer.id,
            "from": "",
            "to": "",
            "message": "",
            "type": "default",
            "user": {
              "name": this.getUserLoginStatus ? "" : this.userData.name,
              "lastName":  this.getUserLoginStatus ? "" : this.userData.lastName,
              "email": this.getUserContact.email || this.userData.email,
              "phone": phoneFormated.replaceAll(' ', '').replaceAll('+', '')
            }
          };
          this.popupLoaded = false;
          this.showRedirectPopupLoaded = false;
          this.showRedirectPopup = true
          await this.addOrder(orderData);
        }
      }

    },
    preparePhone(phone){
      return phone.replaceAll(' ', '').replaceAll('+', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', '')
    },
    closeBookingPopupHandler() {
      this.bookingPopupOpen = false;
      this.pending = false;
      this.popupLoaded = false;
      this.showRedirectPopupLoaded=false;
      this.showRedirectPopup = false;
      this.popupComponentName = "";
      this.errorMessage = '';
    },
    async sendContactBookingHandler(evt) {
      const tourId = this.tour.id;
      const offerId = this.formData.offer.id;
      const peopleCounter = this.getParticipantsCount();
      const {popup, value} = evt;
      this.showRedirectPopup = true;
      this.popupLoaded = false;
      this.showRedirectPopupLoaded=false;
      let userData, orderData = {};
      if(popup == 'send-phone') {
        userData = {
          name: this.userData.name,
          last_name: this.userData.lastName,
          personal_phone: this.preparePhone(value.phone),
          email: this.userData.email,
        };
        orderData = {
          "tourId": tourId,
          "peopleCounter": peopleCounter,
          "date": offerId,
          "from": "",
          "to": "",
          "message": "",
          "type": "default",
          "user": {
            "name": "",
            "lastName": "",
            "email": this.getUserContact.email,
            "phone":  this.preparePhone(value.phone)
          }
        };
        await axiosUser.UpdateFields({
          "data": {
            personalPhone: userData.personal_phone
          }
        }).then(({data})  => {
          if(data.success){
            ytEvents.trackEventRrApiSetEmail(userData.email, i18n.locale);
          }
        })
          .catch(function(error) {
            console.log("error", error);
          });
      }

      if(popup == 'send-contact') {
        userData = {
          name: value.name,
          last_name: value.lastName,
          personal_phone: this.preparePhone(value.phone),
          email:  value.email
        };
        orderData = {
          "tourId": tourId,
          "peopleCounter": peopleCounter,
          "date": offerId,
          "from": "",
          "to": "",
          "message": "",
          "type": "default",
          "user": {
            "name": value.name,
            "lastName": value.lastName,
            "email": value.email,
            "phone": this.preparePhone(value.phone)
          }
        };
      }

      await axiosOrders.updateUserData({
        "value" : userData
      }).then(({data}) => {
        if(data.success){
          ytEvents.trackEventRrApiSetEmail(userData.email, i18n.locale);
          this.addOrder(orderData);
        }
      }).catch(function(error) {
        console.log("error", error);
      });
    },

    async addOrder(orderData){
      let context = this;

      await axiosOrders.orderAdd('default',orderData)
        .then(({data}) => {
          if(data.success) {
            let ytCommission = this.formData.offer.commission * orderData.peopleCounter || 0;
            this.errorMessage = '';
            this.trackEvents("Tour detail", "Booking created", `order_id=${data.data.orderId};place=${this.trackingLabel}`);
            this.trackEvents("Show Success booking popup", "Booking Popup", 'success');
            this.trackEvents('booking', 'want_to_go' , '', {
              tour_id: this.tour.id,
              location: this.tour.country
            });
            try {
              ytEvents.trackEventRrApiAddToBasket(this.tour.id, i18n.locale);
            }
            catch(e) {
              console.log("error", e);
            }
            ytEvents.trackFbq(
              "AddToCart",
              {
                content_ids: [`TOUR-${this.tour.id}`],
                content_type: 'product',
                google_event: 'booking',
                value: ytCommission,
                currency: this.tour.currency.toUpperCase()
              },
              'AddToCartId'
            );
            ytEvents.trackVk(this.tour.id, this.formData.offer.priceValue, this.tour.currency, ytCommission);
            fakeWindow.dataLayer = fakeWindow.dataLayer || [];
            fakeWindow.dataLayer.push({
              'ecommerce': {
                'currencyCode': this.tour.currency.toUpperCase(),
                'add': {
                  'products': [{
                    'name': this.tour.name,
                    'id': `TOUR-${this.tour.id}`,
                    'price': this.formData.offer.priceValue,
                    'brand': `EXPERT-${this.tour.expert_id}`,
                    'variant': data.data.date_variant ? data.data.date_variant : 'No variant',
                    'quantity': orderData.peopleCounter,
                    'dimension4': `${this.tour.country} ${this.tour.region.lenght ? ', '+this.tour.region.lenght  : ''}`,
                    'dimension9': this.tour.type
                  }]
                }
              },
              'event': 'gtm-ee-event',
              'gtm-ee-event-category': 'Enhanced Ecommerce',
              'gtm-ee-event-action': 'Adding a Product to a Shopping Cart',
              'gtm-ee-event-non-interaction': 'False',
            });
            fakeWindow.dataLayer.push({
              'value': ytCommission > 0 ? ytCommission : this.formData.offer.priceValue,//'<?=$iYtCommission ?: $iTourPrice?>',
              'items': [{
                'destination': `TOUR-${this.tour.id}`,
                'google_business_vertical': 'travel'
              }],
              'event': 'add_to_cart'
            });
            this.trackingLabel = '';

            this.paymentUrl = `/lk/pay/?tour_id=${this.tour.id}&order_id=${data.data.orderId}`
          }
        })
        .catch(({ response }) => {
          context.showRedirectPopup = false;
          context.errorMessage = response.data.data.message;
          this.trackEvents("Show Booking error popup", "Booking Popup", context.errorMessage);
        });
    },
    redirectHandler(){
      fakeWindow.location.href = this.paymentUrl;
    },
    triggerIndividualPopup() {
      this.trackEvents("Booking Popup", "Click Submit request as private button");
      if (this.getUserLoginStatus) {
        this.popups.individual = true;
      } else {
        fakeWindow.showVueAuthModal({ "emit-event": "popup-individual" });
      }
    },
    triggerInstallmentPopup() {
      this.popups.installment = true;
    },
    onSubmit(trackingLabel = '') {
      if (this.outOfPlaces) {
        this.pick();
        return;
      }

      if (this.bookingAvailable) {
        this.trackingLabel = trackingLabel;
        this.book();
      }
    },
    getDisabledCustomDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    onPutModalContent() {
      this.pending = false;
    },
    scrollToImportant() {
      this.$scrollTo("#tour-important", 500);
    },
    getParticipantsCount() {
      const participants = localStorage.getItem('participants');

      return participants === null || isNaN(+participants) ? this.formData.participants : +participants;
    },
    getFormattedDateRange,
    trackClickActionButton() {
      let operation = 'Reserve';
      this.trackingLabel = 'Tour detail';
      switch (this.bookingData.operation_id) {
        case 'book':
          operation = 'Reserve';
          break;
        case 'payTour':
          operation = 'Go to payment';
          break;
        case 'postPayTour':
          operation = 'Go to post-payment';
          break;
        case 'awaitConfirm':
          operation = 'Confirmation';
          break;
      }
      this.trackEvents("Tour detail Booking", "Click Action button", operation);
      this.trackEvents("Tour detail", "Click Booking button", this.trackingLabel);
      if(typeof window.youtravel.DataCollector !== "undefined"){
        window.youtravel.DataCollector.trackEvent("Tour detail Booking", "Click Action button", {
          'tour_id': this.tour.id || "",
          'list': "",
          'filter': {},
          'additional': {
            "action": operation,
          },
          'meta': {}
        });
        window.youtravel.DataCollector.trackEvent("Tour detail", "Click Booking button", {
          'tour_id': this.tour.id || "",
          'list': "",
          'filter': {},
          'additional': {
            "action": this.trackingLabel,
          },
          'meta': {}
        })
      }
    },
    trackEvents(cat, name, lbl, props) {
      ytEvents.track(cat, name, lbl, props);
    },
    loadedHandler(){
      this.popupLoaded = true;
      if(this.showRedirectPopup){
        this.showRedirectPopupLoaded = true;
      }
    },
    openMultiSelect() {
      this.trackEvents("Tour detail Booking", "Click Action button",  "Choose Dates");
      this.$refs.bookingPopupFieldset.$refs.multiselectOffers.$refs.multiselect.activate()
    },
    onTooltipShow(name){
      this.trackEvents('Tour detail', 'Show description tooltip', name);
      this.tooltipStartShowTime[name] = Date.now();
    },
    onTooltipHide(name) {
      const tooltipShowTime = (Date.now() - this.tooltipStartShowTime[name]) / 1000;
      this.trackEvents('Tour detail', 'Hide description tooltip', name, {showTime: tooltipShowTime});
    }
  },
};
</script>

<style lang="scss" scoped>
$b: ".booking-popup-mobile";

#{$b} {
  background: var.$white;
  box-shadow: 1px 3px 60px rgba(var.$secondary, 0.35);
  border-radius: var.$rounded-20;
  margin-bottom: 40px;

  &__wrapper {
    background: var.$white;
    border-radius: var.$rounded-20;
    &-container {
      padding: 20px var.$inner-pd 32px;

      @include mixin.size-lg-min {
        padding: 20px 24px 28px;
      }
    }
  }

  &__error {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    &-msg {
      margin-bottom: 30px;
    }
    &-title {
      padding: 0 0 27px 0;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 22px;
      text-align: center;
    }
  }

  &__prices {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 8px;
    cursor: pointer;

    &-original,
    &-result {
      font-size: 24px;
    }

    &-original {
      text-decoration: line-through;
      margin-right: 8px;
    }

    &-result {
      &:not(:last-child) {
        margin-right: 12px;
      }
    }

    &-discount {
      font-weight: bold;
      font-size: 11px;
      line-height: func.divide(12, 11);
      letter-spacing: 0.02em;
      color: var.$white;
      background: var.$red;
      padding: 6px;
      border-radius: var.$rounded-4;
      margin: 2px 0;
    }
  }

  &__s7 {
    display: flex;
    color: #9AAE2D;
    margin-left: auto;
    align-items: center;

    span {
      font-weight: 600;
      font-size: 13px;
      line-height: 17px;
      letter-spacing: -0.02em;
      margin-left: 4px;
    }
  }

  &__utair {
    display: flex;
    color: #003494;
    margin-left: 16px;
    align-items: center;

    span {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: -0.02em;
      margin-left: 4px;
    }
  }


  &__installment {
    background: #ffd700;
    border-radius: 6px;
    width: fit-content;
    padding: 3.5px 6px;
    margin-bottom: 8px;
    cursor: pointer;

    & > span {
      padding-right: 22px;
    }
  }

  &__days {
    display: flex;
    align-items: center;
  }

  &__bonuses {
    display: flex;
    align-items: center;
    margin-top: 8px;
    margin-bottom: 8px;

    &-text {
      color: #8427bd;
    }

    &-tooltip {
      margin-left: 2px;
    }
  }

  &__fieldset {
    margin-top: 28px;

    @include mixin.size-lg-min {
      margin-top: 20px;
    }
  }

  &__left {
    margin-top: 12px;
  }

  &__badges {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin: 32px 0px 0;
    flex-direction: column;
    gap: 6px;
    @include mixin.size-lg-min {
      flex-direction: row;
    }
  }


  &__submit {
    margin-top: 20px;
    #{$b}__submit-button {
      width: 100%;
      @include mixin.size-sm {
        padding: 0 15px;
      }
    }
  }

  &__note {
    margin-top: auto;
    padding-top: 24px;

    .font-text-small--prepay {
      line-height: 18px;
    }
  }

  &__out-of-places {
    &-smile {
      font-size: 40px;
      line-height: 1;
      margin-bottom: 10px;
    }

    &-text {
      margin-bottom: 28px;
    }

    &-submit {
      /* @include mixin.button-reset();*/
      text-decoration: underline;
    }
  }



  &__close {
    @include mixin.button-reset();
    position: absolute;
    top: 124px;
    right: 20px;
    width: 12px;

    &::before {
      @include mixin.full-pos(-50%);
      position: absolute;
      display: block;
      content: "";
    }
  }

  &__preloader {
    padding: 15px;
    border-radius: var.$rounded-20;
    @include mixin.size-md {
      background: var.$white;
      box-shadow: 1px 4px 20px rgba(var.$secondary, 0.35);
    }

    @include mixin.size-lg-min {
      padding: 20px;
    }

    &-container {
      @include mixin.size-md {
        max-width: 48px;
        margin: 0 auto;
      }
    }
  }

  &__individual {
    border-top: 1px solid var.$gray-light;
    margin-top: 24px;
    padding-top: 20px;
    text-align: center;

    &-trigger {
      padding-right: 28px;
    }
  }

  &__add-order {
    min-height: 50px;
    z-index: 1;
    position: relative;
  }
}
.popup-preloader-background{
  height: 50px;
  width:100%;
}
</style>
